<template>
  <v-card class="homepage-v-card">  
<v-card-text class="glass-element">
    <NotificationList :notifications="notifications" />
    </v-card-text>
  </v-card>
</template>

<script>
import NotificationList from "@/components/molecules/NotificationList";
import { mapState } from "vuex";

export default {
  components: { NotificationList },
  methods: {
  },
  computed: mapState({
    notifications: (state) => state.notifications.notifications,
  }),
};
</script>
